import {
    AddDataSharedFunc, DashboardSharedFilterFunc, DashboardSharedFilterKey,
    IDashboardSharedChartData, IDashboardSharedDimensionsViewModel,
} from "models/common";
import { IFilters, IFilterKeys, DimensionsById, ISourceData, IDimension, IDimMDT } from "models/core";

//Plots for this dashboard
import * as PatientsByPeriod from "./patientsByPeriodHierarchy";
import * as PrimarySite from "./primarySiteHierarchy";
import * as Remoteness from "./remoteness";
import * as FirstTreatment from "./firstTreatment";
import { IDashboardViewModel, IDashboardDataQualityComparisonsViewModel } from "./viewModel";

export { type IDashboardDataQualityViewModel, type IDashboardViewModel } from "./viewModel";

export interface IDashboardSource {
    eligible: IDashboardViewModel[];
}

export interface IDashboardDimensionsViewModel extends IDashboardSharedDimensionsViewModel {
    hhsResidenceGroups?: DimensionsById;
    dataQualityIndicators?: DimensionsById;
    monthsArray?: Array<IDimension>;
    yearsArray?: Array<IDimension>;
    months?: { [monthId: number]: string };
    years?: { [yearId: number]: string };
    dqCompFacility?: { [facilityYearKey: string]: number };
    dqCompState?: { [facilityYearKey: string]: number };
    oneYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    threeYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    fiveYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    tenYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    kmSurvival?: { [facCancerKey: string]: { "survivalTime": string, "noMdtKMSurvival": number, "stateKMSurvival": number } };

}

export interface IChartData extends IDashboardSharedChartData {
    patientsByPeriod: PatientsByPeriod.IHierarchyPlotData;
    primarySite: PrimarySite.IHierarchyPlotData;
    remoteness: Remoteness.IPlotData;
    firstTreatment: FirstTreatment.IPlotData;
    month: IDimension[];
    year: IDimension[];
    dqCompFacility:  { [facilityYearKey: string]: number };
    dqCompState: { [facilityYearKey: string]: number };
    oneYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    threeYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    fiveYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    tenYearSurvival?: { [facDiagYearKey: string]: { "Facility": number, "State": number } };
    kmSurvival?: { [facCancerKey: string]: { "survivalTime": string, "noMdtKMSurvival": number, "stateKMSurvival": number } };
    //Computations
    totalPatients: number;
    totalDiagnoses: number;
    totalMaleDiagnoses: number;
    totalIndigenousDiagnoses: number;
    totalDisadvantaged: number;
    totalComorbidity2Plus: number;
    totalLateStage: number;
    medianAgeAtDiagnosis: number;
    // Export
    filteredReferralIdCsv: string;

}

const FilterKey: IFilterKeys = {
    PrimarySite: { key: "PrimarySite", label: "Primary site" },
    Remoteness: { key: "Remoteness", label: "Rurality" },
    FirstTreatment: { key: "FirstTreatment", label: "First Treatment" },
    DiagMonth: { key: "DiagMonth", label: "Diagnosis Month" },
    DiagYear: { key: "DiagYear", label: "Diagnosis Year" },
    AdmMonth: { key: "AdmMonth", label: "Admission Month" },
    AdmYear: { key: "AdmYear", label: "Admission Year" },
}

export const DashboardFilterKeys: IFilterKeys = {
    ...DashboardSharedFilterKey,
    ...FilterKey
}

export type Filters = IFilters<typeof DashboardFilterKeys>;
export type DashboardFilterFunc = DashboardSharedFilterFunc<IDashboardViewModel>;
export type AddDataFunc = AddDataSharedFunc<IDashboardViewModel, ISourceData>;